import styled from "@emotion/styled";

export const HostContainer = styled.span`
  padding: 0;
  margin: 0;

  & > img {
    padding: 0;
    margin: 0;
    max-width: 100%;
    max-height: 100%;
  }
`;
